import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-view-list-icon',
  templateUrl: 'view-list-icon.component.html'
})
export class ViewListIconComponent {
  constructor() {}
}
